import { Form } from "antd";
import isEmpty from "lodash/isEmpty";
import WeaTools from "../../wea-tools";
import WeaFormItem from "../../wea-form-item";
import WeaSearchBrowserBox from "../wea-search-browser-box";

class Main extends React.Component {
  getSearchs() {
    const { browserConditions } = this.props;
    let items = [];
    !isEmpty(browserConditions) &&
      browserConditions.forEach(field => {
        items.push({
          com: (
            <WeaFormItem
              label={`${field.label}`}
              labelCol={{ span: `${field.labelcol}` }}
              wrapperCol={{ span: `${field.fieldcol}` }}
            >
              {WeaTools.getComponent(
                field.conditionType,
                field.browserConditionParam,
                field.domkey,
                this.props,
                field
              )}
            </WeaFormItem>
          ),
          colSpan: 2
        });
      });
    return (
      <WeaSearchBrowserBox
        items={items}
        onKeyDown={this.onAdvanceSearchEnter}
      />
    );
  }
  resetFields = () => {
    const { form } = this.props;
    form.resetFields();
  };
  getFieldsValue = () => {
    const { form } = this.props;
    return form.getFieldsValue();
  };
  getFieldValue = params => {
    const { form } = this.props;
    return form.getFieldValue(params);
  };
  setFieldsValue = (params = {}) => {
    const { form } = this.props;
    form.setFieldsValue(params);
  };
  render() {
    const searchsBox = this.getSearchs();
    return <Form horizontal>{searchsBox}</Form>;
  }
}
Main = Form.create({
  onFieldsChange(props, fields) {
    const { changeCondition } = props;
    Object.keys(fields).forEach(key => {
      if (key === "industry") {
        typeof changeCondition === "function" && changeCondition(fields);
      }
      if (key === "funtions") {
        typeof changeCondition === "function" &&
          changeCondition(fields, "funtions");
      }
    });
  }
})(Main);
export default Main;



// WEBPACK FOOTER //
// ./ecology9/base/wea-ecode-browser/Search.js